import { Guid } from 'guid-typescript';
import { CreateConversationWithRelativePathCommand } from '../collaboration/store/collaboration.command';


/**
 * Created by jayed.talukder on 6/26/2019.
 */
export class TaskManagerHelper {
  public static CreateSupportConversationCommand(payload) {
    console.log('support task:', payload);
    const uniqueId = Guid.create().toString();
    const createConversationCommand = new CreateConversationWithRelativePathCommand();
    createConversationCommand.replativeContextPath = payload.Id.toLowerCase();
    createConversationCommand.conversationId = uniqueId;
    createConversationCommand.title = payload.DisplayId;
    createConversationCommand.conversationType = 2; //todo
    createConversationCommand.sourceType = 'Support';
    createConversationCommand.scope = 3;
    createConversationCommand.isGroupChat = true;
    createConversationCommand.initialMessage = {
      conversationId: uniqueId,
      message: payload.Description,
      messageType: 3 // todo
    };
    return createConversationCommand;
  }
}
